module.exports = __webpack_public_path__ + "static/media/processo.0ff8f681.svg";